var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.proTypedialogVisible,
            title: _vm.title,
            "destroy-on-close": "",
            "close-on-click-modal": false,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.proTypedialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formValidate",
              staticClass: "formValidate mt20",
              attrs: {
                disabled: _vm.isEdit,
                rules: _vm.rules,
                model: _vm.form,
                "label-width": "120px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "景点名称", prop: "scenicName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入景点名称" },
                    model: {
                      value: _vm.form.scenicName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "scenicName", $$v)
                      },
                      expression: "form.scenicName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "详细地址", prop: "address" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入详细地址" },
                    model: {
                      value: _vm.form.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "address", $$v)
                      },
                      expression: "form.address",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "所属景区", prop: "scenicName" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      attrs: {
                        placeholder: "请选择所属景区",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.form.scenicAreaId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "scenicAreaId", $$v)
                        },
                        expression: "form.scenicAreaId",
                      },
                    },
                    _vm._l(_vm.scenicAreaArr, function (item, index) {
                      return _c("el-option", {
                        key: index.id,
                        attrs: { value: item.id, label: item.scenicName },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "开放时间", prop: "adjust" } },
                [
                  _c("el-time-picker", {
                    attrs: {
                      "is-range": "",
                      "is-range": "",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "HH:mm:ss",
                      format: "HH:mm",
                    },
                    model: {
                      value: _vm.form.adjust,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "adjust", $$v)
                      },
                      expression: "form.adjust",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "官方电话", prop: "spotPhone" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入官方电话" },
                    model: {
                      value: _vm.form.spotPhone,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "spotPhone", $$v)
                      },
                      expression: "form.spotPhone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "景点缩略图", prop: "image" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "upLoadPicBox acea-row",
                      on: {
                        click: function ($event) {
                          return _vm.modalPicTap("1")
                        },
                      },
                    },
                    [
                      _vm.form.image
                        ? _c("div", { staticClass: "pictrue" }, [
                            _c("img", { attrs: { src: _vm.form.image } }),
                          ])
                        : _c("div", { staticClass: "upLoad" }, [
                            _c("i", {
                              staticClass: "el-icon-camera cameraIconfont",
                            }),
                          ]),
                    ]
                  ),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v(
                      "请上传图片比例为280px * 170px大小不超过300KB格式为png/jpg/jpeg/webp的文件"
                    ),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "景点详情图", prop: "imagePageList" } },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row" },
                    [
                      _vm._l(_vm.form.imagePageList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "pictrue mr10",
                            attrs: { draggable: "" },
                            on: {
                              dragstart: function ($event) {
                                return _vm.handleDragStart($event, item)
                              },
                              dragover: function ($event) {
                                $event.preventDefault()
                                return _vm.handleDragOver($event)
                              },
                              dragenter: function ($event) {
                                return _vm.handleDragEnter(
                                  $event,
                                  item,
                                  index,
                                  "imagePageList"
                                )
                              },
                              dragend: _vm.handleDragEnd,
                            },
                          },
                          [
                            _c("img", { attrs: { src: item } }),
                            _c("i", {
                              staticClass:
                                "el-icon-error btndel cameraIconfont",
                              on: {
                                click: function ($event) {
                                  return _vm.handleRemoveImagePage(index)
                                },
                              },
                            }),
                          ]
                        )
                      }),
                      _vm.form.imagePageList.length < 10
                        ? _c(
                            "div",
                            {
                              staticClass: "upLoadPicBox",
                              on: {
                                click: function ($event) {
                                  return _vm.modalPicTapPage("2")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "upLoad" }, [
                                _c("i", {
                                  staticClass: "el-icon-camera cameraIconfont",
                                }),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v(
                      " 请上传图片比例为4:3大小不超过300KB格式为png/jpg/jpeg/webp的文件，最多上传10张，可拖拽排序 "
                    ),
                  ]),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "标签名", prop: "tags" } },
                [
                  _c("keyword", {
                    staticClass: "from-ipt-width",
                    attrs: { labelarr: _vm.form.tags },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "景点介绍语音", prop: "audioGuideUrl" } },
                [
                  _c(
                    "div",
                    { staticClass: "acea-row" },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "from-ipt-width",
                          attrs: {
                            size: "small",
                            placeholder: "请输入景点介绍语音",
                          },
                          model: {
                            value: _vm.form.audioGuideUrl,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "audioGuideUrl", $$v)
                            },
                            expression: "form.audioGuideUrl",
                          },
                        },
                        [
                          _c("input", {
                            ref: "refid",
                            staticStyle: { display: "none" },
                            attrs: { type: "file" },
                          }),
                          _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              attrs: {
                                slot: "append",
                                action: "",
                                "http-request": _vm.handleUploadForm,
                                "before-upload": _vm.beforeAvatarUpload,
                                headers: _vm.myHeaders,
                                "show-file-list": false,
                                multiple: "",
                              },
                              slot: "append",
                            },
                            [
                              _c("el-button", { attrs: { size: "small" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.form.audioGuideUrl
                                        ? "确认添加"
                                        : "上传景点介绍语音"
                                    )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "景点介绍" } },
                [
                  _c("Tinymce", {
                    key: 0,
                    model: {
                      value: _vm.form.blurb,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "blurb",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.blurb",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isEdit,
                  expression: "!isEdit",
                },
              ],
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.proTypedialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }